import * as React from 'react';

import type {
  EntWebsiteBlockNativeQuery,
  EntWebsiteNativeFragment,
} from 'bundles/ent-website/__generated__/contentfulTypes';
import BlockLayout, { noImage } from 'bundles/ent-website/contentful/core/BlockLayout';
import Collections from 'bundles/ent-website/contentful/modules/native/Collections';
import NativeError from 'bundles/ent-website/contentful/modules/native/NativeError';
import { entWebsiteBlockNativeQuery } from 'bundles/ent-website/queries/EntWebsiteNative';
import { withBlockQuery } from 'bundles/ent-website/utils/withBlockQuery';
import type { BlockModuleInnerProps } from 'bundles/ent-website/utils/withBlockQuery';

type Props = BlockModuleInnerProps<EntWebsiteNativeFragment>;

export function Native({ content, assembly = {} }: Props) {
  const renderContent = () => {
    switch (content.type) {
      case 'collections':
        return <Collections args={content.arguments} />;
      default:
        // for content author only
        return <NativeError msg={`Unsupported type: ${content.type}`} />;
    }
  };

  return <BlockLayout renderContent={renderContent} assembly={noImage(assembly)} />;
}

// @ts-expect-error TSMIGRATION-5.0 TS2344
export const BlockNative = withBlockQuery<EntWebsiteNativeFragment, EntWebsiteBlockNativeQuery>(
  entWebsiteBlockNativeQuery
)(Native);
